"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import { Icon } from "@/components/formatters/MXPIcon";
import type { FilterableCardsLabelsFields } from "@/queries/fragments/filterableCardsLabelsFragment";
interface PaginationProps {
  currentPage: number;
  pageSize: number;
  totalResults: number;
  pageSizeOptions?: number[];
  onPageChange: (page: number) => void;
  onPageSizeChange: (size: number) => void;
  labels?: FilterableCardsLabelsFields | null;
}
const PAGE_BTN_BASE = "min-w-[36px] h-9 flex items-center justify-center rounded text-sm font-semibold cursor-pointer border-none";
const PAGE_BTN_ACTIVE = "bg-blue-trmb text-white";
const PAGE_BTN_INACTIVE = "bg-transparent text-gray-m7 t2-dark:text-gray-m3 hover:bg-gray-m1 t2-dark:hover:bg-white/10 hover:text-gray-m9 t2-dark:hover:text-white";
const NAV_BTN = "w-9 h-9 flex items-center justify-center rounded cursor-pointer bg-transparent border-none text-gray-m5 t2-dark:text-gray-m3 hover:bg-gray-m1 t2-dark:hover:bg-white/10 hover:text-gray-m9 t2-dark:hover:text-white disabled:opacity-30 disabled:cursor-not-allowed disabled:hover:bg-transparent";
function buildPageNumbers(current: number, total: number, maxVisible: number = 5): (number | "ellipsis")[] {
  if (total <= maxVisible) {
    return Array.from({
      length: total
    }, (_, i) => i + 1);
  }
  const pages: (number | "ellipsis")[] = [];
  const half = Math.floor(maxVisible / 2);
  let start = Math.max(1, current - half);
  let end = start + maxVisible - 1;
  if (end > total) {
    end = total;
    start = Math.max(1, end - maxVisible + 1);
  }
  if (start > 1) {
    pages.push(1);
    if (start > 2) pages.push("ellipsis");
  }
  for (let i = start; i <= end; i++) {
    if (!pages.includes(i)) pages.push(i);
  }
  if (end < total) {
    if (end < total - 1) pages.push("ellipsis");
    pages.push(total);
  }
  return pages;
}
export const Pagination = t0 => {
  const $ = _c(39);
  const {
    currentPage,
    pageSize,
    totalResults,
    pageSizeOptions: t1,
    onPageChange,
    onPageSizeChange,
    labels
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? [30, 60, 90] : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const pageSizeOptions = t2;
  const totalPages = Math.max(1, Math.ceil(totalResults / pageSize));
  const startItem = totalResults === 0 ? 0 : (currentPage - 1) * pageSize + 1;
  const endItem = Math.min(currentPage * pageSize, totalResults);
  const pages = buildPageNumbers(currentPage, totalPages);
  const [jumpValue, setJumpValue] = useState(String(currentPage));
  let t3;
  if ($[2] !== currentPage || $[3] !== jumpValue || $[4] !== onPageChange || $[5] !== setJumpValue || $[6] !== totalPages) {
    t3 = () => {
      const page = parseInt(jumpValue, 10);
      if (!isNaN(page) && page >= 1 && page <= totalPages) {
        onPageChange(page);
      } else {
        setJumpValue(String(currentPage));
      }
    };
    $[2] = currentPage;
    $[3] = jumpValue;
    $[4] = onPageChange;
    $[5] = setJumpValue;
    $[6] = totalPages;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const handleJump = t3;
  const t4 = "flex flex-wrap items-center justify-between gap-4 pt-8 pb-4 border-t border-gray-m2 t2-dark:border-gray-m7 mt-8";
  const t5 = labels?.labelForResults || "Results";
  let t6;
  if ($[8] !== t5) {
    t6 = <span className="font-semibold">{t5}:</span>;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== onPageSizeChange) {
    t7 = e => onPageSizeChange(Number(e.target.value));
    $[10] = onPageSizeChange;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== pageSizeOptions) {
    t8 = pageSizeOptions.map(_temp);
    $[12] = pageSizeOptions;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== pageSize || $[15] !== t7 || $[16] !== t8) {
    t9 = <select className="border border-gray-m3 rounded px-2 py-1 text-sm bg-white text-gray-m9 cursor-pointer" value={pageSize} onChange={t7}>{t8}</select>;
    $[14] = pageSize;
    $[15] = t7;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t6 || $[19] !== t9) {
    t10 = <div className="flex items-center gap-2 text-sm text-gray-m7 t2-dark:text-gray-m3">{t6}{t9}</div>;
    $[18] = t6;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  const t11 = labels?.labelForShowing || "Showing";
  let t12;
  if ($[21] !== endItem || $[22] !== startItem) {
    t12 = <span className="font-bold text-gray-m9 t2-dark:text-white">{startItem}-{endItem}</span>;
    $[21] = endItem;
    $[22] = startItem;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== t11 || $[25] !== t12 || $[26] !== totalResults) {
    t13 = <div className="text-sm text-gray-m7 t2-dark:text-gray-m3">{t11}{" "}{t12}{" "}/ {totalResults}</div>;
    $[24] = t11;
    $[25] = t12;
    $[26] = totalResults;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  const t14 = totalPages > 1 && <div className="flex items-center gap-1"><button className={NAV_BTN} disabled={currentPage === 1} onClick={() => onPageChange(1)} aria-label={labels?.labelForFirstPage || "First page"}><Icon type="t2u-chevron-right" size={10} rotateDeg="180" /><Icon type="t2u-chevron-right" size={10} rotateDeg="180" /></button><button className={NAV_BTN} disabled={currentPage === 1} onClick={() => onPageChange(currentPage - 1)} aria-label={labels?.labelForPreviousPageButton || "Previous Page"}><Icon type="t2u-chevron-right" size={12} rotateDeg="180" /></button>{pages.map((page_0, i) => page_0 === "ellipsis" ? <span key={`ellipsis-${i}`} className="w-9 h-9 flex items-center justify-center text-gray-m5 t2-dark:text-gray-m3 text-sm">...</span> : <button key={page_0} className={`${PAGE_BTN_BASE} ${page_0 === currentPage ? PAGE_BTN_ACTIVE : PAGE_BTN_INACTIVE}`} onClick={() => onPageChange(page_0)} aria-current={page_0 === currentPage ? "page" : undefined}>{page_0}</button>)}<button className={NAV_BTN} disabled={currentPage === totalPages} onClick={() => onPageChange(currentPage + 1)} aria-label={labels?.labelForNextPageButton || "Next Page"}><Icon type="t2u-chevron-right" size={12} /></button><button className={NAV_BTN} disabled={currentPage === totalPages} onClick={() => onPageChange(totalPages)} aria-label={labels?.labelForLastPage || "Last page"}><Icon type="t2u-chevron-right" size={10} /><Icon type="t2u-chevron-right" size={10} /></button></div>;
  let t15;
  if ($[28] !== handleJump || $[29] !== jumpValue || $[30] !== labels?.labelForPage || $[31] !== setJumpValue || $[32] !== totalPages) {
    t15 = totalPages > 1 && <div className="flex items-center gap-2 text-sm text-gray-m7 t2-dark:text-gray-m3"><span>{labels?.labelForPage || "Page"}</span><input type="text" className="w-12 border border-gray-m3 rounded px-2 py-1 text-sm text-center bg-white text-gray-m9" value={jumpValue} onChange={e_0 => setJumpValue(e_0.target.value)} onBlur={handleJump} onKeyDown={e_1 => {
        if (e_1.key === "Enter") {
          handleJump();
        }
      }} /><span>/ {totalPages}</span></div>;
    $[28] = handleJump;
    $[29] = jumpValue;
    $[30] = labels?.labelForPage;
    $[31] = setJumpValue;
    $[32] = totalPages;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  let t16;
  if ($[34] !== t10 || $[35] !== t13 || $[36] !== t14 || $[37] !== t15) {
    t16 = <div className={t4}>{t10}{t13}{t14}{t15}</div>;
    $[34] = t10;
    $[35] = t13;
    $[36] = t14;
    $[37] = t15;
    $[38] = t16;
  } else {
    t16 = $[38];
  }
  return t16;
};
function _temp(size) {
  return <option key={size} value={size}>{size}</option>;
}